import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RequestMapper, ServerResponseMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { Relative } from "../Models/Relative";
import { RelativeFileUIModel } from "../Models/UI/RelativeFileUIModel";
import { RelativeActions } from "./RelativeActions";
import { RelativeHandler } from "./RelativeHandler";
import { RelativeResponseHandler } from "./RelativeResponseHandler";

let defaultInstance: RelativeStore;

class RelativeStore extends BaseStore {
    // State
    public relatives: { [relativeContactId: string]: Relative } = {};
    public relativeFiles: { [relativeContactId: string]: RelativeFileUIModel } = {};
    public selectedPersonContactId?: string;

    // Actions
    public actions: RelativeActions;

    // Handlers
    private localHandler: RelativeHandler;
    private serverResponseHandler: RelativeResponseHandler;

    // Mappers
    private requestMapper: RequestMapper;
    private serverResponseMapper: ServerResponseMapper;

    constructor() {
        super();
        this.actions = new RelativeActions();
        this.localHandler = new RelativeHandler();
        this.requestMapper = new RequestMapper();
        this.requestMapper.AddInstance(this.localHandler);
        this.serverResponseHandler = new RelativeResponseHandler(this.actions);
        this.serverResponseMapper = new ServerResponseMapper();
        this.serverResponseMapper.AddInstance(this.serverResponseHandler);

        // Register dispatchers
        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => this.requestMapper.Map(request, this));
        this.ServerDispatchToken = ServerResponseDispatcher.register((response: ServerEvent) => { this.serverResponseMapper.Map(response, this); });
    }

    /**
     * Get current relative.
     */
    public GetCurrent(): Relative {
        return this.relatives[this.selectedPersonContactId];
    }

    /**
     * Get current relative file.
     */
    public GetCurrentFile(): RelativeFileUIModel {
        return this.relativeFiles[this.selectedPersonContactId];
    }

    public static createSingleton(): RelativeStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new RelativeStore());
    }
}

RelativeStore.createSingleton();

export { RelativeStore, defaultInstance as relativeStore };
